/* eslint-disable import/no-named-as-default */
/* eslint-disable no-shadow */
import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  HashRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import ErrorBoundary from "../shared/error/ErrorBoundary";
import ActionBar from "../shared/general/ActionBar";
import PendingReviewsTable from "./PendingReviewsTable";
import LeaveReview from "./LeaveReview";

export interface IPendingReviewsProps {
  loading: boolean;
  actionBarTitle: string;
  formSubmittedSuccessfully: boolean;
}

export const PendingReviews: FunctionComponent<IPendingReviewsProps> = ({
  loading,
  actionBarTitle,
  formSubmittedSuccessfully,
}) => (
  <ErrorBoundary>
    <Router>
      <ActionBar
        capitalize
        title={actionBarTitle}
        mobileTitle={actionBarTitle}
        loading={loading}
      />
      {formSubmittedSuccessfully && <Redirect to="/" />}
      <Switch>
        <Route exact path="/" component={PendingReviewsTable} />
        <Route exact path="/:jobId/leave-a-review" component={LeaveReview} />
      </Switch>
    </Router>
  </ErrorBoundary>
);

PendingReviews.propTypes = {
  loading: PropTypes.bool.isRequired,
  actionBarTitle: PropTypes.string.isRequired,
  formSubmittedSuccessfully: PropTypes.bool.isRequired,
};

interface IReduxState {
  employerPendingReviews: {
    loading: boolean;
    actionBarTitle: string;
    formSubmittedSuccessfully: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  loading: state.employerPendingReviews.loading,
  actionBarTitle: state.employerPendingReviews.actionBarTitle,
  formSubmittedSuccessfully:
    state.employerPendingReviews.formSubmittedSuccessfully,
});

export default connect(mapStateToProps, {})(PendingReviews);
